import { Text } from "@/components/ui/baseUi/text"
import { word } from "@modules/core/utils/i18n"

/**
 * CoachFinancesPage is a placeholder page for the coach finances details. It currently displays a title, but it can be expanded in the future to include more information and functionality related to the coach finances.
 */
export function CoachFinancesPage() {
  return (
    <div className="relative min-h-full w-full bg-surface-background-default p-6">
      <Text fontStyle="HL" className="font-semibold text-textOnSurface-default">
        {word("menu.finances")}
      </Text>
    </div>
  )
}
